import { useReducer, useCallback } from 'react';

function modalsReducer(modals, action) {
  const { type, name, ...rest } = action;

  switch (type) {
    case 'open': {
      return {
        ...modals,
        [name]: {
          open: true,
          ...rest,
        },
      };
    }
    case 'close': {
      return {
        ...modals,
        [name]: {
          open: false,
          ...rest,
        },
      };
    }
    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
}

export default () => {
  const [modals, dispatch] = useReducer(modalsReducer, {});

  const closeModal = useCallback((name, params = {}) => {
    dispatch({
      type: 'close',
      name,
      params,
    });
  }, []);

  const openModal = useCallback((name, params = {}) => {
    dispatch({
      type: 'open',
      name,
      params,
    });
  }, []);

  return {
    ...modals,
    closeModal,
    openModal,
  };
};
